/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useCallback, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../../../../../app/common/_customHooks/redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { actions, selectors } from "../../../../../app/user-access/_redux";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const getMenuItemActive = (location, url) => {
  return checkIsActive(location, url) ? " menu-item-active menu-item-open " : "";
};

export function AsideMenuList({ layoutProps }) {
  const items = useSelector(state => {
    return selectors.getMenu(state);
  }, shallowEqual);

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {Array.isArray(items) && items.length 
            ? items.map(item => <NavItem key={item.id} item={item} />)
            : <div className="d-flex">
                <Spinner className="mx-auto mt-8 mb-1" animation="border" variant="secondary" />
              </div>}
      </ul>
    </>
  );
}

function NavItem({ item }) {
  return item.items && item.value.toLowerCase() !== 'dashboard'? <NodeWithChildren item={item} /> : <SingleNode item={item} />;
}

function SingleNode({ item }) {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const isActive = getMenuItemActive(location, item.url);

  useEffect(() => {
    if (isActive && item.tabbedItems) {
      dispatch(actions.setTabMenuItems(item.tabbedItems));
    }
  }, [isActive, item.tabbedItems, dispatch]);

  const setTabNav = e => {
    if (item.tabbedItems) {
      dispatch(actions.setTabMenuItems(item.tabbedItems));
    } else {
      dispatch(actions.setTabMenuItems([]));
    }
  }

  return (
    <li className={`menu-item ${isActive}`}>
      <NavLink className="menu-link" to={item.url} onClick={setTabNav}>
        <ItemIcon item={item} />
        <span className="menu-text">{t(`Menu.${item.label}`)}</span>
      </NavLink>
    </li>
  );
}

function NodeWithChildren({ item }) {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const menuLoading = useSelector(state => {
    return selectors.isMenuLoading(state);
  }, shallowEqual);

  const LoadItems = useCallback(() => {
    if (item.items.length === 0 && !menuLoading) {
        dispatch(actions.fetchSubMenuItems(item.id));
    }
  }, [item.id, item.items.length, menuLoading, dispatch]);

  const isActive = getMenuItemActive(location, item.url);

  useEffect(() => {
    if (isActive) LoadItems(item);
  }, [isActive]);

  return (
    <li
      className={`menu-item menu-item-submenu ${isActive}`}
      data-menu-toggle="hover"
    >
      <NavLink className="menu-link menu-toggle" to={item.url} onClick={() => LoadItems(item)}>
        <ItemIcon item={item} />
        <span className="menu-text">{t(`Menu.${item.label}`)}</span>
        <i className="menu-arrow" />
      </NavLink>
        <div className="menu-submenu">
          <i className="menu-arrow" />
          <ul className="menu-subnav">
            <li className="menu-item  menu-item-parent">
              <span className="menu-link">
                <span className="menu-text">{t(`Menu.${item.label}`)}</span>
              </span>
            </li>
            {item.items.length ? (
              item.items.map(item => <NavItem key={item.id} item={item} />)
            ) : (
              <Spinner className="mx-auto mt-5 mb-1" animation="border" variant="secondary" size="sm" />
            )}
          </ul>
        </div>
    </li>
  );
}

function ItemIcon({ item }) {
  return item.svgIconUrl ? (
    <span className="svg-icon menu-icon">
      <SVG src={toAbsoluteUrl(item.svgIconUrl)} onError={(e) => console.warn('SVG failed to load', e)} />
    </span>
  ) : null;
}
